import React from 'react';

/**
 * Representación rectangular horizontal de la cinta/grado.
 */
export default function BeltIcon({ type, className = "w-16 h-6" }) {
  const belts = {
    'blanca': { bg: '#FFFFFF', border: '#E5E7EB', stripe: null },
    'blanca_avanzada': { bg: '#FFFFFF', border: '#E5E7EB', stripe: '#FACC15' },
    'amarilla': { bg: '#FACC15', border: '#EAB308', stripe: null },
    'amarilla_avanzada': { bg: '#FACC15', border: '#EAB308', stripe: '#22C55E' },
    'verde': { bg: '#22C55E', border: '#16A34A', stripe: null },
    'verde_avanzada': { bg: '#22C55E', border: '#16A34A', stripe: '#3B82F6' },
    'azul': { bg: '#3B82F6', border: '#2563EB', stripe: null },
    'azul_avanzada': { bg: '#3B82F6', border: '#2563EB', stripe: '#713F12' },
    'marron': { bg: '#713F12', border: '#452108', stripe: null },
    'marron_avanzada': { bg: '#713F12', border: '#452108', stripe: '#EF4444' },
    'roja': { bg: '#EF4444', border: '#B91C1C', stripe: null },
    'roja_avanzada': { bg: '#EF4444', border: '#B91C1C', stripe: '#18181b' },
    'negra_1': { bg: '#18181b', border: '#000000', dan: 1 },
    'negra_2': { bg: '#18181b', border: '#000000', dan: 2 },
    'negra_3': { bg: '#18181b', border: '#000000', dan: 3 },
    'negra_4': { bg: '#18181b', border: '#000000', dan: 4, master: true },
    'negra_5': { bg: '#18181b', border: '#000000', dan: 5, master: true },
    'negra_6': { bg: '#18181b', border: '#000000', dan: 6, master: true },
    'negra_7': { bg: '#18181b', border: '#000000', dan: 7, master: true },
    'negra_8': { bg: '#18181b', border: '#000000', dan: 8, master: true },
    'negra_9': { bg: '#18181b', border: '#000000', dan: 9, master: true }
  };

  const config = belts[type] || belts['blanca'];

  return (
    <div 
      className={`relative rounded-md overflow-hidden border shadow-inner flex items-center justify-center ${className}`}
      style={{ 
        backgroundColor: config.bg, 
        borderColor: config.border 
      }}
    >
      {/* Franja de grado avanzado (Vertical en rectángulo horizontal) */}
      {config.stripe && (
        <div 
          className="absolute inset-y-0 w-1/4 shadow-sm"
          style={{ backgroundColor: config.stripe }}
        />
      )}

      {/* Dans para cintas negras (Barras verticales cortas) */}
      {config.dan && (
        <div className={`flex ${config.dan > 5 ? 'gap-px' : 'gap-1'}`}>
          {[...Array(config.dan)].map((_, i) => (
            <div 
              key={i} 
              className={`${config.dan > 5 ? 'w-0.5' : 'w-1'} h-3 rounded-full`} 
              style={{ backgroundColor: config.master && i === 0 ? '#EF4444' : '#D4AF37' }} 
            />
          ))}
        </div>
      )}
      
      {/* Efecto de textura de tela */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-black/5 pointer-events-none" />
    </div>
  );
}